import React, { useEffect, useState } from "react";
import {
  FiStar,
  FiShoppingCart,
  FiCreditCard,
  FiTruck,
  FiRefreshCw,
  FiCheckCircle,
  FiChevronRight,
  FiShield,
} from "react-icons/fi";
import { Link, useParams } from "react-router-dom";
import SimilarProduct from "../components/SimilarProduct";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from "sweetalert2";
import LoginModal from "../components/LoginModal";
import ProductReview from "./component/ProductReview";
import Wishlist from "../components/Wishlist";
import Wishlist2 from "../components/Wishlist2";
import { useCart } from '../context/CartContext';
import CheckPincode from "./component/CheckPincode";

function ProductDetail() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  // const [mainImage, setMainImage] = useState("");
  const [thumbnails, setThumbnails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVariant, setSelectedVariant] = useState(null);
  // const [fade, setFade] = useState(false);
  const [loginModal, setLoginModal] = useState(false);

  const [mainImage, setMainImage] = useState(thumbnails[0]);
  const [fade, setFade] = useState(false);
  const [showModal, setShowModal] = useState(false);


  // const [mainImage, setMainImage] = useState(thumbnails[0]);
  // const [fade, setFade] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  // Function to change main image in the main view
  const handleImageChange = (img) => {
    if (img === mainImage) return;
    setFade(true);
    setTimeout(() => {
      setMainImage(img);
      setFade(false);
    }, 200);
  };

  // Smoothly change the main image with a fade effect
  // const handleImageChange = (img) => {
  //   if (img === mainImage) return;
  //   setFade(true);
  //   setTimeout(() => {
  //     setMainImage(img);
  //     setFade(false);
  //   }, 200);
  // };


  const showToast = (icon, title) => {
    Swal.fire({
      toast: true,
      icon,
      title,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      background: "#fff",
    });
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${baseurl}getProductBySlug/${slug}`);
        if (res.data.success) {
          const p = res.data.product;
          setProduct(p);
          if (p.images?.length > 0) {
            const imgs = p.images.map((img) => `${imgurl}${img.image_path}`);
            setThumbnails(imgs);
            setMainImage(imgs[0]);
          } else if (p.variants?.[0]?.variant_json?.images?.[0]) {
            const vImgs = p.variants[0].variant_json.images.map(
              (img) => `${imgurl}${img.path}`
            );
            setThumbnails(vImgs);
            setMainImage(vImgs[0]);
          }
        }
      } catch (err) {
        console.error("❌ Fetch product error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [slug]);






const { cartCount, fetchCartCount } = useCart();

const handleAddToCart = async () => {
  const customerId = localStorage.getItem("customerId");
  if (!customerId) {
    setLoginModal(true);
    return;
  }

  try {
    const payload = {
      product_id: product.id,
      variant: selectedVariant || "",
      quantity: 1,
      customerId,
    };

    const res = await axios.post(`${baseurl}addToCart`, payload);

    if (res.data.success) {
      showToast("success", "✅ Product added to cart!");
      
      // ✅ 2. Trigger the global context refresh
      // This ensures the Topbar icon updates immediately without a page reload
      fetchCartCount(); 
      
    } else {
      showToast("error", res.data.message || "⚠️ Failed to add to cart.");
    }
  } catch (err) {
    const errorMessage = err.response?.data?.message || "❌ Something went wrong.";
    showToast("error", errorMessage); 
    console.error("Stock Error:", err.response?.data);
  }
};











  const handleBuyNow = async () => {
    const customerId = localStorage.getItem("customerId");
    if (!customerId) {
      setLoginModal(true);
      return;
    }
    try {
      const payload = {
        product_id: product.id,
        variant: selectedVariant || null,
        quantity: 1,
        customerId,
      };
      const res = await axios.post(`${baseurl}addToCart`, payload);
      if (res.data.success) {
        showToast("success", "✅ Redirecting to cart...");
        setTimeout(() => (window.location.href = "/cart"), 1200);
      }
    } catch (err) {
      showToast("error", "❌ Something went wrong.");
    }
  };

  // const handleImageChange = (img) => {
  //   setFade(true);
  //   setTimeout(() => {
  //     setMainImage(img);
  //     setFade(false);
  //   }, 150);
  // };
// Open Lightbox at a specific image
  const openLightbox = (index) => {
    setModalIndex(index);
    setShowModal(true);
  };


  if (loading) {
    return (
      <div className="container py-5">
        <div className="row">
          <div className="col-md-5"><Skeleton height={450} borderRadius={15} /></div>
          <div className="col-md-7">
            <Skeleton height={40} width="60%" className="mb-3" />
            <Skeleton count={5} className="mb-2" />
          </div>
        </div>
      </div>
    );
  }

  if (!product) return <div className="text-center py-5">Product not found.</div>;

  const {
    name,
    price,
    mrp,
    description,
    category_name,
    category_slug,
    subcategory_name,
    subcategory_slug,
    variants,
    total_reviews,
    average_rating,
    reviews,
    id,
    uuid,

  } = product;

  const categories = [
    { name: "Home", slug: "" },
    category_name && { name: category_name, slug: category_slug },
    subcategory_name && { name: subcategory_name, slug: subcategory_slug },
    { name },
  ].filter(Boolean);

  const variantOptions = variants?.map((v) => ({ ...v.variant_json })) || [];

  return (
    <div className="product-detail-wrapper">
      <div className="container py-3">
        {/* 🧭 Breadcrumb */}
        <nav aria-label="breadcrumb" className="custom-breadcrumb mb-4">
          <ol className="breadcrumb m-0">
            {categories.map((cat, idx) => {
              const isLast = idx === categories.length - 1;
              let link = "/";
              if (idx === 1) link = `/category/${cat.slug}`;
              else if (idx === 2) link = `/shop/${categories[1]?.slug}/${cat.slug}`;

              return (
                <li key={idx} className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                  {isLast ? cat.name : (
                    <Link to={link}>
                      {cat.name} <FiChevronRight className="sep" />
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>

        <div className="row g-4">
          {/* 🖼️ LEFT: IMAGES */}
<div className="col-lg-5 col-md-6">
      <div className="sticky- d-flex gap-3" style={{ top: "100px" }}>
        
        {/* 1. Thumbnails Column (Left) */}
        <div className="thumb-column d-none d-sm-flex flex-column gap-2">
          {thumbnails.slice(0, 5).map((thumb, i) => {
            const isLastShown = i === 4 && thumbnails.length > 5;
            const remainingCount = thumbnails.length - 5;

            return (
              <div
                key={i}
                className={`thumb-vertical-item ${mainImage === thumb ? "active" : ""} ${isLastShown ? "more-images-trigger" : ""}`}
                onClick={() => isLastShown ? openLightbox(i) : handleImageChange(thumb)}
              >
                <img src={thumb} alt="thumbnail" className="img-fluid" />
                
                {isLastShown && (
                  <div className="overlay-blur">
                    <span>+{remainingCount + 1}</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* 2. Main Image (Right) */}
        <div 
          className={`main-image-container flex-grow-1 cursor-zoom ${fade ? "fade-out" : "fade-in"}`}
          onClick={() => openLightbox(thumbnails.indexOf(mainImage))}
        >
          <img src={mainImage} alt={name} className="img-fluid main-img-v2 shadow-sm" />
        </div>
      </div>

      {/* 3. Image Lighthouse (Modern Gallery Modal) */}
      {showModal && (
        <div className="lightbox-overlay" onClick={() => setShowModal(false)}>
          <button className="lightbox-close" onClick={() => setShowModal(false)}>&times;</button>
          
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            {/* Large Preview */}
            <div className="lightbox-main-view">
              <img 
                src={thumbnails[modalIndex]} 
                alt="Full Preview" 
                className="img-fluid lightbox-big-img" 
              />
              
              {/* Navigation Arrows */}
              <button 
                className="nav-arrow prev" 
                onClick={() => setModalIndex((modalIndex - 1 + thumbnails.length) % thumbnails.length)}
                disabled={thumbnails.length <= 1}
              >&#10094;</button>
              <button 
                className="nav-arrow next" 
                onClick={() => setModalIndex((modalIndex + 1) % thumbnails.length)}
                disabled={thumbnails.length <= 1}
              >&#10095;</button>
            </div>

            {/* Bottom Thumbnail Strip */}
            <div className="lightbox-thumbnails">
              {thumbnails.map((img, idx) => (
                <div 
                  key={idx} 
                  className={`lightbox-thumb-item ${modalIndex === idx ? 'active' : ''}`}
                  onClick={() => setModalIndex(idx)}
                >
                  <img src={img} alt="nav" />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <style>
        {`
        .cursor-zoom { cursor: zoom-in; }

        /* Sidebar Thumbnail Column */
        .thumb-column {
          width: 80px;
          flex-shrink: 0;
          max-height: 550px;
          overflow-y: auto;
          scrollbar-width: none;
        }
        .thumb-column::-webkit-scrollbar { display: none; }

        .thumb-vertical-item {
          width: 100%;
          aspect-ratio: 3/4;
          cursor: pointer;
          border: 1px solid #f0f0f0;
          border-radius: 4px;
          overflow: hidden;
          transition: 0.3s;
          position: relative;
        }
        .thumb-vertical-item img { width: 100%; height: 100%; object-fit: cover; }
        .thumb-vertical-item.active { border: 2px solid #ff3f6c; }

        .more-images-trigger .overlay-blur {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          backdrop-filter: blur(3px);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 500;
          
          font-size: 1.1rem;
        }

        .main-img-v2 {
          width: 100%;
          height: auto;
          aspect-ratio: 3/4;
          object-fit: cover;
          border-radius: 8px;
        }

        /* --- LIGHTHOUSE MODAL STYLES --- */
        .lightbox-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.95);
          z-index: 10000;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .lightbox-close {
          position: absolute;
          top: 20px;
          right: 30px;
          background: none;
          border: none;
          color: white;
          font-size: 40px;
          cursor: pointer;
          z-index: 10001;
        }

        .lightbox-content {
          width: 90%;
          max-width: 1000px;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .lightbox-main-view {
          position: relative;
          width: 100%;
          height: 70vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .lightbox-big-img {
          max-height: 100%;
          max-width: 100%;
          object-fit: contain;
          border-radius: 4px;
          animation: zoomIn 0.3s ease-out;
        }

        @keyframes zoomIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }

        .nav-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.1);
          color: white;
          border: none;
          padding: 15px 20px;
          font-size: 24px;
          cursor: pointer;
          border-radius: 50%;
          transition: 0.3s;
        }
        .nav-arrow:hover { background: rgba(255,255,255,0.3); }
        .nav-arrow.prev { left: -60px; }
        .nav-arrow.next { right: -60px; }

        .lightbox-thumbnails {
          display: flex;
          justify-content: center;
          gap: 10px;
          padding: 10px;
          overflow-x: auto;
        }

        .lightbox-thumb-item {
          width: 60px;
          height: 80px;
          cursor: pointer;
          border: 2px solid transparent;
          border-radius: 4px;
          opacity: 0.6;
          transition: 0.3s;
        }
        .lightbox-thumb-item img { width: 100%; height: 100%; object-fit: cover; }
        .lightbox-thumb-item.active { border-color: #ff3f6c; opacity: 1; transform: scale(1.1); }

        /* Animation Classes */
        .fade-in { animation: fadeIn 0.4s ease-in; }
        .fade-out { opacity: 0; transition: opacity 0.2s; }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @media (max-width: 768px) {
           .nav-arrow.prev { left: 10px; }
           .nav-arrow.next { right: 10px; }
           .lightbox-content { width: 95%; }
        }
        `}
      </style>
    </div>

          {/* 📋 MIDDLE: PRODUCT DETAILS */}
          <div className="col-lg-7 col-md-6">
  <div className="product-content-card">
    <span className="brand-tag">{category_name}</span>
    <h1 className="product-title">{name}</h1>

    <div className="rating-row mb-4">
      <div className="stars-pill">
        {average_rating || "0"} <FiStar className="ms-1" />
      </div>
      <span className="review-count">{total_reviews} Ratings </span>
    </div>

    <div className="price-box mb-4">
      <h2 className="current-price">₹{selectedVariant?.price || price}</h2>
      {(selectedVariant?.mrp || mrp) && (
        <span className="original-mrp">₹{selectedVariant?.mrp || mrp}</span>
      )}
      <span className="discount-pill">
        {Math.round(
          (((selectedVariant?.mrp || mrp) - (selectedVariant?.price || price)) /
            (selectedVariant?.mrp || mrp)) *
            100
        )}
        % OFF
      </span>
    </div>

    {/* 🔹 Variants */}
    {variantOptions.length > 0 && (
      <div className="variant-wrapper mb-4">
        <h6 className="section-subtitle">Select Color/Variant</h6>
        <div className="variant-options">
          <div
            className={`v-option ${!selectedVariant ? "selected" : ""}`}
            onClick={() => {
              setSelectedVariant(null);
              const defaultImgs =
                product.images?.map((img) => `${imgurl}${img.image_path}`) || [];
              setMainImage(defaultImgs[0] || "");
              setThumbnails(defaultImgs);
            }}
          >
            Original
          </div>
          {variantOptions.map((v, idx) => (
            <div
              key={idx}
              className={`v-option ${selectedVariant === v ? "selected" : ""}`}
              onClick={() => {
                setSelectedVariant(v);
                const vImgs = v.images?.map((img) => `${imgurl}${img.path}`) || [];
                if (vImgs.length > 0) {
                  setMainImage(vImgs[0]);
                  setThumbnails(vImgs);
                }
              }}
            >
              {v.images?.[0] && (
                <img
                  src={`${imgurl}${v.images[0].path}`}
                  className="v-thumb"
                  alt=""
                />
              )}
              {v.name || v.colorName || "Variant"}
            </div>
          ))}
        </div>
      </div>
    )}

    {/* 🔹 Stock Status (Dynamic) */}
    <div className="stock-status-container mb-4">
      {(() => {
        const stockValue = selectedVariant 
          ? Number(selectedVariant.stock) 
          : Number(product.stock);

        return stockValue > 0 ? (
          <div className="d-flex align-items-center gap-2">
            <span className="badge bg-success-light text-success border-success px-3 py-2">
              In Stock
            </span>
            {stockValue <= 5 && (
              <span className="text-danger fw-bold small animate-pulse">
                Only {stockValue} left!
              </span>
            )}
          </div>
        ) : (
          <span className="badge bg-danger-light text-danger border-danger px-3 py-2">
            Out of Stock
          </span>
        );
      })()}
    </div>

    {/* Action Buttons (Desktop) */}
    <div className="d-none d-md-flex gap-3 mb-5">
      <button
        className="btn-cart flex-fill"
        onClick={handleAddToCart}
        disabled={(selectedVariant ? Number(selectedVariant.stock) : Number(product.stock)) <= 0}
      >
        <FiShoppingCart className="me-2" />
        {(selectedVariant ? Number(selectedVariant.stock) : Number(product.stock)) > 0
          ? "Add to Cart"
          : "Out of Stock"}
      </button>

      <Wishlist2 productId={id} />
    </div>


    <div>
      <CheckPincode />
    </div>

    {/* 🧾 Attributes Table */}
    {product.attributes && Object.keys(product.attributes).length > 0 && (
      <div className="specs-section">
        <h5 className="section-subtitle mb-3">Specifications</h5>
        {Object.entries(product.attributes).map(([section, attrs]) => (
          <div key={section} className="mb-4">
            <h6 className="spec-group-title">{section}</h6>
            <div className="spec-table">
              {Object.entries(attrs).map(([key, value]) => (
                <div className="spec-row" key={key}>
                  <div className="spec-key">{key}</div>
                  <div className="spec-val">{value}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )}

    {/* 📝 Description */}
    {description && (
      <div className="description-section mt-5">
        <h5 className="section-subtitle">About this item</h5>
        <div
          className="desc-content"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    )}
  </div>

  <style>{`
    .bg-success-light { background-color: #e7f7ed; border: 1px solid #d1f0db; }
    .bg-danger-light { background-color: #fdeaea; border: 1px solid #fad2d2; }
    .btn-cart:disabled { background-color: #ccc; cursor: not-allowed; border-color: #ccc; }
    @keyframes pulse {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
    }
    .animate-pulse { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
  `}</style>
</div>
        </div>

        {/* 🧑‍💬 REVIEWS */}
<ProductReview productId={product.id} /> 
 
      </div>

      {/* 📱 Mobile Fixed Bottom Bar */}
      <div className="mobile-action-bar d-md-none">
        <button className="m-btn-cart" onClick={handleAddToCart}><FiShoppingCart /> Cart</button>
        <button className="m-btn-buy" onClick={handleBuyNow}>Buy Now</button>
      </div>

      <LoginModal show={loginModal} onClose={() => setLoginModal(false)} />

      <style>{`
        .product-detail-wrapper { background: #fdfdfd; min-height: 100vh; color: #333; }
        
        /* Breadcrumb */
        .custom-breadcrumb .breadcrumb-item { font-size: 0.85rem; display: flex; align-items: center; }
        .custom-breadcrumb a { color: #888; text-decoration: none; }
        .custom-breadcrumb .sep { margin: 0 8px; font-size: 0.7rem; color: #ccc; }
        .custom-breadcrumb .active { color: #333; font-weight: 600; }

        /* Gallery */
        .main-image-container { background: #fff; border: 1px solid #f0f0f0; border-radius: 20px; padding: 30px; display: flex; align-items: center; justify-content: center; min-height: 450px; overflow: hidden; }
        .main-img { max-height: 400px; object-fit: contain; transition: 0.3s; }
        .thumb-grid { display: flex; gap: 12px; flex-wrap: wrap; }
        .thumb-item { width: 70px; height: 70px; border-radius: 10px; border: 2px solid #f0f0f0; cursor: pointer; padding: 5px; transition: 0.3s; background: #fff; }
        .thumb-item.active { border-color: #007bff; }
        .thumb-item img { width: 100%; height: 100%; object-fit: contain; }

        /* Product Content */
        .product-content-card { padding: 10px; }
        .brand-tag { color: #007bff; font-weight: 700; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 1px; }
        .product-title { font-size: 1.67rem; font-weight: 600; margin: 10px 0; 
        font-family: "Open Sans", sans-serif;
        line-height: 1.2; color: #1a1a1a; }
        
        /* Rating */
        .stars-pill { background: #28a745; color: #fff; padding: 4px 12px; border-radius: 50px; font-size: 0.9rem; font-weight: 600; display: inline-flex; align-items: center; }
        .review-count { color: #777; font-size: 0.9rem; margin-left: 15px; }

        /* Pricing */
        .current-price { font-size: 1.89rem; font-weight: 600; color: #111; display: inline-block; }
        .original-mrp { text-decoration: line-through; color: #999; font-size: 1.2rem; margin: 0 15px; }
        .discount-pill { color: #d9534f; font-weight: 700; font-size: 1rem; }

        /* Variants */
        .v-option { border: 1px solid #ddd; padding: 8px 16px; border-radius: 12px; cursor: pointer; transition: 0.2s; display: flex; align-items: center; gap: 8px; font-weight: 500; }
        .v-option.selected { border-color: #007bff; background: #f0f7ff; color: #007bff; box-shadow: 0 4px 10px rgba(0,123,255,0.1); }
        .v-thumb { width: 25px; height: 25px; border-radius: 4px; object-fit: cover; }
        .variant-options { display: flex; gap: 10px; flex-wrap: wrap; }

        /* Buttons */
        .btn-cart { background: #ffc107; border: none; padding: 15px; border-radius: 12px; font-weight: 700; transition: 0.3s; }
        .btn-cart:hover { background: #e0ac00; transform: translateY(-2px); }
        .btn-buy { background: #fb641b; color: #fff; border: none; padding: 15px; border-radius: 12px; font-weight: 700; transition: 0.3s; }
        .btn-buy:hover { background: #e65a16; transform: translateY(-2px); }

        /* Services Grid */
        .services-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 20px; background: #fff; border: 1px solid #f0f0f0; padding: 20px; border-radius: 15px; }
        .s-item { display: flex; gap: 10px; align-items: center; }
        .s-icon { font-size: 1.5rem; color: #007bff; }
        .s-item h6 { font-size: 0.85rem; margin: 0; font-weight: 700; }
        .s-item p { font-size: 0.75rem; margin: 0; color: #777; }

        /* Specs Table */
        .spec-group-title { font-size: 1rem; border-bottom: 2px solid #eee; padding-bottom: 8px; margin-bottom: 15px; font-weight: 700; }
        .spec-row { display: flex; padding: 10px 0; border-bottom: 1px solid #f9f9f9; }
        .spec-key { width: 35%; color: #888; font-size: 0.9rem; }
        .spec-val { width: 65%; font-weight: 500; font-size: 0.9rem; }

        /* Description */
        .desc-content { line-height: 1.8; color: #555; font-size: 0.95rem; }

        /* Review Card */
        .review-card { display: flex; gap: 15px; padding: 20px; background: #f9f9f9; border-radius: 15px; margin-bottom: 15px; }
        .review-card img { width: 50px; height: 50px; border-radius: 50%; }

        /* Mobile Action Bar */
        .mobile-action-bar { position: fixed; bottom: 0; left: 0; width: 100%; display: flex; background: #fff; padding: 12px; box-shadow: 0 -5px 15px rgba(0,0,0,0.05); z-index: 999; gap: 10px; }
        .m-btn-cart { flex: 1; background: #fff; border: 2px solid #ffc107; border-radius: 10px; font-weight: 700; padding: 12px; }
        .m-btn-buy { flex: 1; background: #fb641b; color: #fff; border: none; border-radius: 10px; font-weight: 700; padding: 12px; }

        .fade-in { animation: fadeIn 0.3s ease-in; }
        .fade-out { opacity: 0.5; transition: 0.15s; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }

        @media (max-width: 768px) {
          .product-title { font-size: 1.4rem; }
          .current-price { font-size: 1.8rem; }
          .main-image-container { min-height: 300px; }
          .product-page { padding-bottom: 80px; }
        }
      `}</style>
    </div>
  );
}

export default ProductDetail;